import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataSourceType } from '../wizardTypes';

interface Props {
  onSelect: (type: DataSourceType) => void;
}

const ChooseTypeStep: React.FC<Props> = ({ onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-text dark:text-text-dark">{t('wizard.chooseType.title')}</h2>
        <p className="text-muted dark:text-muted-dark mt-2">{t('wizard.chooseType.subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
        <button
          onClick={() => onSelect('supplier')}
          className="rounded-2xl border-2 border-zinc-200 dark:border-zinc-700 hover:border-emerald-500 dark:hover:border-emerald-500 cursor-pointer transition-all p-8 text-left group"
        >
          <div className="w-12 h-12 rounded-xl bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center mb-4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-emerald-600 dark:text-emerald-400" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
              <polyline points="3.29 7 12 12 20.71 7" />
              <line x1="12" y1="22" x2="12" y2="12" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-text dark:text-text-dark group-hover:text-emerald-600 dark:group-hover:text-emerald-400 transition-colors">
            {t('wizard.chooseType.supplier')}
          </h3>
          <p className="text-sm text-muted dark:text-muted-dark mt-1">
            {t('wizard.chooseType.supplierDescription')}
          </p>
        </button>

        <button
          onClick={() => onSelect('revenue')}
          className="rounded-2xl border-2 border-zinc-200 dark:border-zinc-700 hover:border-emerald-500 dark:hover:border-emerald-500 cursor-pointer transition-all p-8 text-left group"
        >
          <div className="w-12 h-12 rounded-xl bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mb-4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-blue-600 dark:text-blue-400" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="1" x2="12" y2="23" />
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-text dark:text-text-dark group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
            {t('wizard.chooseType.revenue')}
          </h3>
          <p className="text-sm text-muted dark:text-muted-dark mt-1">
            {t('wizard.chooseType.revenueDescription')}
          </p>
        </button>
      </div>
    </div>
  );
};

export default ChooseTypeStep;
